/* eslint-disable */
import axios from 'axios';
export function get(_this, info, showError, returnOnFail, callback){
    axios.get(info.api)
		.then(res => {
			//console.log(res.data)
            //this.apiResult = res.data
            callback(res.data, _this)         
        })
        .catch(function (error) {
            // handle error
            if ( showError ){
                var msg = createErrorMsg(window.apiJson.default["error"]["WEBAPP_CATCH_ERROR"], info)
                alert(msg)                
            }
            if (returnOnFail ){
                callback(null, _this)
            }
            return;
        })
        .then(function () {
            // always executed
        });
}


export function post(_this, info, callback){   
    realPostCall(_this, info, function(res2, ___this){
        callback(res2, ___this)
    });
}

function realPostCall(_this, info,  callback){      
    axios.post(info.api, info.params || {})
        .then(res => {               
            callback(res.data, _this)
        })
        .catch(function (error) {                
                callback(null, _this)                
        })
        .then(function () {
            // always executed
        });        
}
